import { ImgHTMLAttributes } from 'react'
import styled from 'styled-components'
import { getTheme } from '../theme/utils'

const getStyleValue = (value: string | number): string => {
    if (typeof value === 'string') return value
    return `${value}px`
}

const StyledImage = styled.img<{
    $width: string | number
    $height: string | number
}>`
    width: ${({ $width }) => getStyleValue($width)};
    height: ${({ $height }) => getStyleValue($height)};
`

const imageWithSrc =
    (
        src: string | undefined
    ): React.VFC<{
        width?: number | string
        height?: number | string
        props?: ImgHTMLAttributes<HTMLImageElement>
    }> =>
    ({ width = 'auto', height = 'auto', props = {} }) => {
        return <StyledImage {...props} src={src} $width={width} $height={height} />
    }

export const ThemedHeroImage: React.FC = ({ children }) => {
    const theme = getTheme()
    if (theme.images?.hero) {
        const Component = imageWithSrc(theme.images.hero)
        return <Component width={130} />
    }
    return <>{children}</>
}
